/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import ReactHTMLParser from 'react-html-parser';
import Typography from '@material-ui/core/Typography';
import  Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import {
    object, shape, string, arrayOf, number, bool,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';
import { compose } from 'recompose';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({
    productName: {
        textAlign: 'left',
        fontWeight: 700,
        fontSize: 16,
    },
    productPrice: {
        textAlign: 'left',
        fontWeight: 700,
        fontSize: 16,
        '& >span': {
            fontWeight: 'normal',
        },
    },
    imageCard: {
        width: '100%',
        marginBottom: 8,
        borderRadius: 0,
        position: ' relative',
        boxShadow: `0 2px 4px 0 ${theme?.palette?.imageCardBoxShadow}`,
    },
    productImage: {
        display: 'block',
        width: 'inherit',
    },
    productList: {
        padding: 8,
        '& a': {
            textDecoration: 'none',
            fontSize: 16,
            color: theme?.palette?.sectionHeaderTextColor,
        },

    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        color: theme?.palette?.colorAlert,
        fontWeight: 'normal',
    },
    salePrice: {
        color: theme?.palette?.primaryButton,
    },
    title: {
        textAlign: 'center',
        fontSize: 20,
        margin: '0 0 15px',
    },
    bestSeller: {
        textAlign: 'center',
        justifyContent: 'center',
        '& h4': {
            fontWeight: 600,
            fontSize: 32,
            padding: '8px',
            margin: 0,
            lineHeight: 1,
            [theme.breakpoints.down('xs')]: {
                fontSize: 20,
            },
        },
    },
    subHeading: {
        fontSize: 20,
        fontWeight: 400,
        padding: 8,
        [theme.breakpoints.down('xs')]: {
            fontSize: 14,
        },
    },
    shopButton: {
        color: theme?.palette?.white,
        backgroundColor: theme?.palette?.continueShoppingBg,
        padding: '8px 16px',
        fontSize: 14,
        boxSizing: 'border-box',
        textTransform: 'uppercase',
        fontWeight: 500,
        borderRadius: 4,
        boxShadow: `0px 1px 5px 0px ${theme?.palette?.imageCardBoxShadow}`,
        margin: '8px 0',
        display: 'inline-block',
        '&:hover': {
            backgroundColor: theme?.palette?.giftGuideHoverColor,
            textDecoration: 'none',
        },
    },
    passportEligibleImage: {
        width: '50%',
        display: 'block',
        marginBottom: '3px',
    },
});

const productList = (classes, data, flags, numberOfProducts) => {
    const seed = useUIDSeed();
    return  data.map((product, i) => {
        const {
            skuPriceRange,
            isPassportEligible,
        } = product;
        const { sale, retail } = skuPriceRange || {};
        if (product?.seo?.url && i < numberOfProducts) {
            return (
                <Grid key={seed(product)} item xs={6} sm={3} md={3} lg={3} className={classes.productList}>
                    <Grid item xs={12}>
                        <Link
                            to={`${product?.seo?.url}`}
                            className={classes.product}
                        >
                            <Card className={classes.imageCard}>
                                <img
                                    src={`${product?.image?.path}${product?.image?.name}x.jpg`} // to do: do not hardcode the x and change based on screensize?
                                    alt={product?.name}
                                    className={classes.productImage}
                                />
                            </Card>
                            {isPassportEligible && flags && flags['is-prime-free-ship-icon-enabled'] === true ? <img className={classes.passportEligibleImage} src="https://cdn4.1800flowers.com/wcsstore/Flowers/images/2020/passport/PPEligibleIcon.jpg" alt="passport_eligible" /> : null}
                            <Grid container direction="column">
                                <Grid item xs={12}>
                                    <Typography className={classes.productName}>{ReactHTMLParser(product?.name)}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className={classes.productPrice}>
                                        <span>from</span> {(sale && sale?.length > 1 && sale?.[0]?.value.toString() === retail?.[0]?.value.toString() && sale?.[1]?.value.toString() === retail?.[1]?.value.toString()) ? (
                                            `$${retail?.[0]?.value} - $${retail?.[1]?.value}`
                                        ) : (
                                            <div>
                                                {retail && retail?.length > 1 && sale && sale?.length > 0
                                                && (<><span className={classes.crossedOutRetailPrice}>${retail?.[0]?.value} - ${retail?.[1]?.value}</span> <span className={classes.salePrice}> {product?.sale || null} ${sale?.[0]?.value} - ${sale?.[1]?.value}</span></>)}
                                            </div>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Link>
                    </Grid>
                </Grid>
            );
        }
        return null;
    });
};

const BestSellerGiftGuide = ({
    classes, bestSeller, subNavCollection,
    flags,
}) => {
    const products  = subNavCollection?.products || [];
    const numberOfProducts = bestSeller?.number_of_products || 4;
    return (
        <Grid container className={classes.bestSeller}>
            <Grid item xs={12}>
                <h4> {bestSeller?.heading}</h4>
                <div className={classes.subHeading}> {bestSeller?.sub_heading}</div>
                {bestSeller?.link?.href ?  <Link className={classes.shopButton} to={bestSeller?.link?.href}>{bestSeller?.link?.title}</Link> : null}
            </Grid>

            {products && products.length > 0
                ? productList(classes, products, flags, numberOfProducts) : null}

        </Grid>
    );
};
BestSellerGiftGuide.propTypes = {
    classes: object.isRequired,
    bestSeller: shape({
        heading: string.isRequired,
        sub_heading: string.isRequired,
        link: shape({
            href: string.isRequired,
            title: string.isRequired,
        }),

    }).isRequired,
    subNavCollection: shape({
        product: arrayOf(
            shape({
                prices: arrayOf(
                    shape({
                        __typename: string.isRequired,
                        currency: string.isRequired,
                        type: string.isRequired,
                        value: number.isRequired,
                    }).isRequired,
                ).isRequired,
                skuPriceRange: shape({
                    sale: arrayOf(
                        shape({
                            value: number.isRequired,
                        }),
                    ),
                    retail: arrayOf(
                        shape({
                            value: number.isRequired,
                        }),
                    ),
                }).isRequired,
                seo: shape({
                    url: string.isRequired,
                }).isRequired,
                image: shape({
                    name: string.isRequired,
                    path: string.isRequired,
                }),
                sale: string,
                isPassportEligible: bool.isRequired,
            }),
        ),

    }).isRequired,

    flags: object.isRequired,
};

const mapStateToProps = (state) => ({
    flags: getFeatureFlags(state),
});

const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps),
);
export default enhance(BestSellerGiftGuide);
